import SearchIcon from '@mui/icons-material/Search';
import { Box, FormControl, InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TextFieldStyled from '../../../shared/TextFieldStyled';

interface SearchInputProps {
    callback?: VoidFunction;
}

export const SearchInput: React.FC<SearchInputProps> = (props) => {
    const { callback } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { register, handleSubmit } = useForm<{ search: string }>();

    const goToSearchPage = (data) => {
        if (data.search.length > 0) {
            navigate({
                pathname: '/search',
                search: '?q=' + data.search,
            });

            callback?.();
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <form onSubmit={handleSubmit(goToSearchPage)}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                >
                    <FormControl fullWidth>
                        <TextFieldStyled
                            label={t('HEADER.SEARCH').toString()}
                            {...register('search')}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton type="submit" edge="end">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>
                </Box>
            </form>
        </Box>
    );
};
